import TranslationHelper from '@/app/helpers/TranslationHelper';

export function getGridTitle(sourceSet: any, isAnalyticsEnabled: boolean) {
    if (sourceSet && isAnalyticsEnabled) {
        return `${TranslationHelper.translate(
            sourceSet.label
        )} (${TranslationHelper.translate(
            'Analytics'
        )} ${TranslationHelper.translate('BETA')})`;
    }
    if (sourceSet) {
        return TranslationHelper.translate(sourceSet.label);
    }
    return TranslationHelper.translate('Loading...');
}
